export default __webpack_public_path__ + "static/media/img-see-results.c6d05ebb.png";